/**
 * Générateur — Il lit, interprète et représente des données sous forme de
 * diagrammes circulaires.
 * Attendu ID : 164 | Niveau : 4ème | Domaine : Données/Statistiques (descripteur 14)
 *
 * Source : doc prof OGD/FONCTIONS 4e, objectif O1. Le doc est MUET en exercices
 * texte (exos en image seulement, cf. §5 TODO_EXERCISEUR_4E) → banque créée de
 * zéro, dans l'esprit du programme 4e (lire / interpréter / REPRÉSENTER).
 *
 * Cartes (état d'origine, juillet 2026) :
 *   « Lire un diagramme circulaire » — camembert (% affichés) d'un sondage ;
 *     QCM, saisie, tableau d'effectifs (trous), V/F d'interprétation.
 *   « Du pourcentage à l'effectif (et retour) » — même camembert, les deux sens.
 *   « Construire : l'angle d'un secteur » — un tableau d'effectifs (total
 *     DIVISEUR de 360) → angle = eff/total × 360° (entier). Saisie, tableau
 *     d'angles (trous), QCM formule, relier.
 *
 * Revue 2026-09-23 (vague 3), décisions du coordinateur appliquées en mode
 * auto. Attendu de fin de 4e (Eduscol, attendus de fin d'année, p. 5) : « Il
 * lit, interprète et représente des données sous forme de diagrammes
 * circulaires. » Exemples de réussite : un disque SANS AUCUN nombre (« Âge des
 * adhérents du club d'échecs du collège », légende des âges seulement, le
 * secteur 13 ans dépasse la moitié, le secteur 14 ans est un quart) ;
 * « Construis un diagramme circulaire à partir du tableau suivant : Âges 11,
 * 13, 14, 15 / Effectifs 5, 20, 9, 2 ». Cours (19Statist, partie 3,
 * « Diagramme circulaire (Rappel) ») : « Les angles sont proportionnels aux
 * effectifs », « L'effectif total (24) correspond au disque entier (360°) »,
 * coefficient 360 ÷ 24 = 15, rapporteur. Le cran de 4e : le secteur de plus de
 * 180° et l'interprétation.
 *   - Rappel brouillon IMPÉRATIF sur toutes les cartes (RAPPEL_BROUILLON),
 *     juste avant la question : l'attendu inclut la construction (360 ÷ total,
 *     tableau de proportionnalité), qui se fait à la main ; la règle est par
 *     attendu, la carte de lecture le porte donc aussi.
 *   - Carte « Du pourcentage à l'effectif » SORTIE (convertir_texte,
 *     convertir_qcm_unique) : les deux sens sont les automatismes 1127 et
 *     1128, et les pourcentages ne sont ni dans l'exemple de réussite ni dans
 *     la partie « diagramme circulaire » du cours ; le QCM comptait en plus une
 *     réponse juste pour fausse (« 600 ÷ 10 » quand la part est 10 %, 17,8 %
 *     des tirages). Avec elle part le seul camembert à effectifs, donc le
 *     sous-titre « Total » que le disque recouvrait (le défaut reste dans
 *     svgCamembert pour un sous-titre sans titre, hors de ce gen).
 *   - lire_texte SORTIE : même tâche que « pourcentage vers effectif », déjà
 *     l'automatisme 1128.
 *   - lire_qcm_unique RECADRÉE sur l'exemple de réussite : disque sans aucun
 *     nombre (légende des réponses seulement), question « Quelle part des …
 *     a choisi « X » ? », quatre réponses fixes « Un quart », « La moitié »,
 *     « Trois quarts », « Plus de la moitié » ; le secteur X fait un quart,
 *     la moitié, ou plus de la moitié (55 à 65 %, l'exemple : 13 ans = 56 %),
 *     un tiers des tirages chacun ; un secteur de plus de 180° dans la moitié
 *     des tirages « un quart » et dans tous les tirages « plus de la moitié ».
 *     Écart du correcteur, mode auto, À ARBITRER : les trois familles DEPP
 *     (2de 2025 q.15 : degres_pour_pourcent 90 %, demi_disque 45 %,
 *     parts_egales 20 %, chiffrées sur un angle DROIT) ne donnent trois
 *     mauvaises réponses plausibles que pour le secteur d'un quart ; pour la
 *     moitié et au-delà elles tombent au-dessus de 100 % ou sur la clé. Elles
 *     nomment donc les mauvaises réponses là où elles s'appliquent (contrat
 *     REGLES_DISTRACTEURS_QCM) ; « Trois quarts » n'est jamais la clé (un
 *     secteur de trois quarts rendrait vraie aussi « Plus de la moitié »).
 *   - lire_texte_trou_saisie GARDÉE (diagramme ↔ tableau, DEPP 4e 2023 q.19,
 *     le disque porte les pourcentages comme dans l'item) : une ligne par
 *     réponse « Sport : … élèves » au lieu d'une ligne jointe par des tirets
 *     cadratins, « Combien d'élèves ont choisi chaque réponse ? Complète. » au
 *     lieu de « Complète le tableau » sans tableau ; un secteur de plus de
 *     50 % dans un tirage sur quatre.
 *   - lire_tableau_vf RECADRÉE sur le disque sans nombre : quatre lignes, une à
 *     trois vraies (quota tiré), une réponse au plus par ligne et une ligne au
 *     plus par tournure, lues sur les angles (« Un quart … », « La moitié … »,
 *     « Plus de la moitié … », « Moins de la moitié … », « la moins choisie »,
 *     deux réponses réunies) ; fausses nommées quand une erreur l'explique
 *     (degres_pour_pourcent : un quart dit « plus de la moitié » ; demi_disque :
 *     un quart dit « la moitié » ; parts_egales : un secteur quelconque dit
 *     « un quart ») ; toute ligne est décidable sans mesurer : écart d'au moins
 *     10 % (36°) entre ce qui est affirmé et ce qui est dessiné, 5 % (18°) pour
 *     « plus / moins de la moitié » face à un secteur de 55 %, le niveau de
 *     l'exemple (13 ans : 20° au-delà du demi-disque). La tautologie « un pourcentage plus grand
 *     correspond à un plus grand effectif » sort. « Un quart » est écrit sans
 *     « environ » (les décisions disaient « environ un quart ») : le secteur
 *     vrai est exactement un angle droit, et « environ » rendrait indécidable
 *     un secteur de 30 ou 35 % (mode auto, À ARBITRER).
 *   - angle_texte GARDÉE : chaque contexte nomme ses objets (« Fruit »,
 *     « Couleur », « Âge »… plus de fruits appelés « réponses », 24,6 %) ;
 *     totaux 20, 24, 30, 36, 40, 45, 60, 72, 90 (45 ajouté) ; le total est dans
 *     une colonne « Total » du tableau, comme dans le cours, au lieu d'une
 *     parenthèse ; la parenthèse qui répétait l'effectif du secteur sort ;
 *     l'exemple de réussite (club d'échecs, 11 à 15 ans) devient un contexte.
 *   - angle_texte_trou_saisie : la forme du cours, sans formule dans la
 *     consigne (elle était donnée dans 100 % des tirages) : « 24 personnes
 *     pour 360°, donc 1 personne pour {{15}}° », puis « Bleu : 10 élèves, soit
 *     {{150}}° », une ligne par réponse (plus de tiret cadratin).
 *   - angle_qcm_unique : quatre calculs de même forme, sans résultat (la clé
 *     était la seule option qui portait « = résultat », 100 %), en KaTeX ; clé
 *     sous la forme du cours e × (360 ÷ total) ; distracteurs nommés
 *     degres_pour_pourcent e × (100 ÷ total), demi_disque e × (180 ÷ total),
 *     mauvais_diviseur e × (360 ÷ 100) (l'effectif traité comme un
 *     pourcentage : « pourcentage × 3,6 » de 5e appliqué à l'effectif).
 *     Résiduel mesuré, mode auto, À ARBITRER : la clé est toujours le calcul
 *     de plus grande valeur (100 % des tirages), parce que les trois erreurs de
 *     la décision diminuent toutes l'angle (100 ou 180 au lieu de 360 ; 100 au
 *     lieu d'un total d'au plus 90) ; les options sont des calculs sans
 *     résultat, l'élève ne voit pas les valeurs. Parade possible, non
 *     appliquée faute d'erreur attestée : une famille qui agrandit l'angle.
 *   - angle_relier : TROIS réponses, CINQ angles dont deux leurres nommés
 *     (demi_disque, degres_pour_pourcent, mauvais_diviseur, calculés sur les
 *     réponses affichées, entiers), « Deux angles sont en trop. » ; au moins un
 *     leurre tombe entre le plus petit et le plus grand angle juste, pour que
 *     ranger ne suffise pas (apparier par le rang réussissait 100 %).
 *   - Figures : attribut alt sur chaque disque (sans la réponse) ; secteurs de
 *     plus de 180° admis ; le module de 5e n'est pas modifié (imgAvecAlt de
 *     donnees.js pose l'alt).
 *   - Contrat des distracteurs exporté (REGLES_DISTRACTEURS_QCM), codes dans
 *     _meta.params.distracteurs.
 * Sept formats (dix avant), dont deux QCM.
 */
import {
    randomChoice, randInt, shuffle,
    makeQcm, makeSaisie, makeVraiFaux, makeTexteTrou, makeRelier, tex,
} from '../../../utils';
import { svgCamembert, tableEnonce, ligneTable } from '../../5eme/statistiques/svgStats';
import { effectifSecteur, imgAvecAlt } from './donnees';

const ATTENDU_ID = 164;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_LIRE = 'Lire un diagramme circulaire';
// « Calculer » et non plus « Construire » : aucune carte ne fait tracer le
// secteur (revue du coordinateur, 2026-09-23).
const L_ANGLE = 'Calculer l\'angle d\'un secteur';

// Rappel brouillon (décision 2026-09-23), IMPÉRATIF pour tout l'attendu : la
// construction se fait à la main (360 ÷ total, tableau de proportionnalité).
// Forme maison du parc (gen_149, gen_162) ; juste avant la question.
const RAPPEL_BROUILLON = '<p class="italic text-slate-400">✏️ Pose tes calculs au brouillon.</p>';

/** Élision « de » → « d' » devant une unité à voyelle (ex. « d'élèves »). */
const deU = (u) => (/^[aeiouéèêàâîïûh]/i.test(u) ? `d'${u}` : `de ${u}`);

// ─── Contextes de sondage (4 réponses chacun, comme l'exemple de réussite) ───
// `interroges` : le groupe accordé (« élèves interrogés », « personnes
// interrogées ») pour « Quelle part des … a choisi … ? ».
const CONTEXTES = [
    { sujet: 'leur loisir préféré', cats: ['Sport', 'Lecture', 'Jeux vidéo', 'Musique'], unite: 'élèves', complement: ' d\'un collège', interroges: 'élèves interrogés' },
    { sujet: 'leur moyen de transport pour aller au collège', cats: ['À pied', 'Vélo', 'Bus', 'Voiture'], unite: 'élèves', complement: '', interroges: 'élèves interrogés' },
    { sujet: 'leur parfum de glace préféré', cats: ['Vanille', 'Chocolat', 'Fraise', 'Pistache'], unite: 'personnes', complement: '', interroges: 'personnes interrogées' },
    { sujet: 'leur couleur préférée', cats: ['Bleu', 'Rouge', 'Vert', 'Jaune'], unite: 'personnes', complement: '', interroges: 'personnes interrogées' },
    { sujet: 'leur animal de compagnie', cats: ['Chien', 'Chat', 'Oiseau', 'Poisson'], unite: 'familles', complement: ' d\'un quartier', interroges: 'familles interrogées' },
];

/** Intro d'un sondage ; `total` absent → « des élèves », présent → « 400 élèves ». */
const introSondage = (ctx, total) =>
    `<p>On a interrogé ${total ? total : 'des'} ${ctx.unite}${ctx.complement} sur ${ctx.sujet}. `
    + 'Le diagramme circulaire donne la répartition des réponses.</p>';

/** Disque SANS nombre (légende des réponses seulement), avec son alt. */
const disqueSansNombre = (ctx, pcts) => imgAvecAlt(
    svgCamembert(ctx.cats.map((nom, i) => ({ nom, pct: pcts[i] })), { labelsSurSecteurs: false }),
    `Diagramme circulaire sans aucun nombre, quatre secteurs de couleurs différentes ; légende : ${ctx.cats.join(', ')}.`);

/** Disque avec le pourcentage écrit dans chaque secteur (carte à trous, DEPP 4e 2023 q.19). */
const disqueEnPourcentages = (ctx, pcts) => imgAvecAlt(
    svgCamembert(ctx.cats.map((nom, i) => ({ nom, pct: pcts[i] })), { labelsSurSecteurs: true }),
    `Diagramme circulaire, le pourcentage écrit dans chaque secteur : ${ctx.cats.map((c, i) => `${c} ${pcts[i]} %`).join(', ')}.`);

// ═════════════════════════════════════════════════════════════
// CARTE « Lire un diagramme circulaire »
// ═════════════════════════════════════════════════════════════

// Parts d'un disque sans nombre : multiples de 5 %, au moins 5 %. Le secteur
// visé X vaut un quart (25), la moitié (50) ou plus de la moitié (55 à 65) ;
// les trois autres sont deux à deux distincts et distincts de X.
const triplets = (somme, exclus) => {
    const out = [];
    for (let a = 5; a <= somme; a += 5) {
        for (let b = a + 5; b <= somme; b += 5) {
            const c = somme - a - b;
            if (c > b && ![a, b, c].some((p) => exclus.includes(p))) out.push([a, b, c]);
        }
    }
    return out;
};

// Un quart : aucun autre secteur d'un quart ni d'une moitié (X seul repère
// lisible) ; avec ou sans secteur de plus de la moitié (l'exemple : 13 ans).
const AUTRES_QUART = triplets(75, [25, 50]);
const AUTRES_QUART_AVEC_GRAND = AUTRES_QUART.filter((t) => t[2] > 50);
const AUTRES_QUART_SANS_GRAND = AUTRES_QUART.filter((t) => t[2] <= 45);
const AUTRES_MOITIE = triplets(50, [50]);
const GRANDS = [55, 60, 65];
const AUTRES_GRAND = Object.fromEntries(GRANDS.map((g) => [g, triplets(100 - g, [g])]));

/**
 * Parts d'un disque « lire » dont un secteur est la cible : 'quart', 'moitie'
 * ou 'plus'. Renvoie { pcts (dans l'ordre des secteurs), iX }.
 */
const tirerDisque = (cible) => {
    let x;
    let autres;
    if (cible === 'quart') {
        x = 25;
        autres = randInt(0, 1) === 0 ? randomChoice(AUTRES_QUART_AVEC_GRAND) : randomChoice(AUTRES_QUART_SANS_GRAND);
    } else if (cible === 'moitie') {
        x = 50;
        autres = randomChoice(AUTRES_MOITIE);
    } else {
        x = randomChoice(GRANDS);
        autres = randomChoice(AUTRES_GRAND[x]);
    }
    const pcts = shuffle([x, ...autres]);
    if (pcts.reduce((a, b) => a + b, 0) !== 100) throw new Error(`gen_164 : parts ${pcts}`);
    return { pcts, iX: pcts.indexOf(x) };
};

// Les quatre réponses fixes de la décision, et ce que chacune affirme d'une part p (%).
const PARTS_LUES = ['Un quart', 'La moitié', 'Trois quarts', 'Plus de la moitié'];
const VRAIE_SI = {
    'Un quart': (p) => p === 25,
    'La moitié': (p) => p === 50,
    'Trois quarts': (p) => p === 75,
    'Plus de la moitié': (p) => p > 50,
};
const CLE_DE = { quart: 'Un quart', moitie: 'La moitié', plus: 'Plus de la moitié' };

// L'erreur qui mène à chaque mauvaise réponse, selon la part du secteur visé.
const CODES_LIRE = {
    quart: { 'La moitié': 'demi_disque', 'Plus de la moitié': 'degres_pour_pourcent', 'Trois quarts': 'complementaire' },
    moitie: { 'Un quart': 'parts_egales', 'Plus de la moitié': 'degres_pour_pourcent', 'Trois quarts': 'repere_voisin' },
    plus: { 'Un quart': 'parts_egales', 'La moitié': 'repere_voisin', 'Trois quarts': 'repere_voisin' },
};

const genLireQcm = () => {
    const ctx = randomChoice(CONTEXTES);
    const cible = randomChoice(['quart', 'moitie', 'plus']);
    const { pcts, iX } = tirerDisque(cible);
    const x = pcts[iX];
    const bonne = CLE_DE[cible];
    // Second chemin : chaque réponse évaluée sur la part dessinée, une seule vraie.
    const vraies = PARTS_LUES.filter((r) => VRAIE_SI[r](x));
    if (vraies.length !== 1 || vraies[0] !== bonne) throw new Error(`gen_164 : lire ${x} → ${vraies}`);
    const payload = makeQcm(PARTS_LUES, bonne,
        introSondage(ctx)
        + RAPPEL_BROUILLON
        + `<p><b>Quelle part des ${ctx.interroges} a choisi « ${ctx.cats[iX]} » ?</b></p>`,
        opts(L_LIRE));
    payload.elements_additionnels = disqueSansNombre(ctx, pcts);
    payload._meta.params = {
        cible, pcts, secteur: ctx.cats[iX], part: x,
        distracteurs: PARTS_LUES.filter((r) => r !== bonne).map((r) => CODES_LIRE[cible][r]),
    };
    return payload;
};

// Carte à trous : le disque porte les pourcentages (DEPP 4e 2023 q.19). Parts
// au moins 10 % (l'étiquette tient dans le secteur) ; un jeu sur quatre a un
// secteur de plus de 50 %.
const PARTS_ETIQUETEES = [
    [10, 20, 30, 40], [15, 20, 25, 40], [10, 25, 30, 35],
    [10, 15, 35, 40], [10, 20, 25, 45], [15, 20, 30, 35], [10, 15, 30, 45],
];
const PARTS_ETIQUETEES_GRAND = [
    [55, 10, 15, 20], [60, 10, 10, 20], [55, 10, 10, 25], [65, 10, 10, 15], [60, 10, 15, 15],
];
const TOTAUX = [200, 300, 400, 500, 600, 800];

const genLireTrous = () => {
    const ctx = randomChoice(CONTEXTES);
    const pcts = shuffle(randInt(1, 4) === 1 ? randomChoice(PARTS_ETIQUETEES_GRAND) : randomChoice(PARTS_ETIQUETEES));
    const total = randomChoice(TOTAUX);
    const effs = pcts.map((p) => effectifSecteur(p, total));
    // Second chemin : effectifs entiers, somme = total.
    if (effs.some((e) => !Number.isInteger(e)) || effs.reduce((a, b) => a + b, 0) !== total) {
        throw new Error(`gen_164 : effectifs ${effs} pour ${total}`);
    }
    const phrase = ctx.cats.map((c, i) => `${c} : {{${effs[i]}}} ${ctx.unite}`).join('\n');
    const payload = makeTexteTrou(phrase,
        introSondage(ctx, total)
        + RAPPEL_BROUILLON
        + `<p><b>Combien ${deU(ctx.unite)} ont choisi chaque réponse ? Complète.</b></p>`,
        { ...opts(L_LIRE), mode: 'saisie', strict: false });
    payload.elements_additionnels = disqueEnPourcentages(ctx, pcts);
    payload._meta.params = { pcts, total, effs };
    return payload;
};

// V/F sur le disque sans nombre. Chaque ligne affirme une part lisible ; elle
// n'est écrite vraie ou fausse que si l'écart entre ce qu'elle affirme et ce
// qui est dessiné est net (au moins 10 %, 36° ; 5 %, 18°, pour « plus / moins
// de la moitié » face à un secteur de 55 %, comme l'exemple de réussite),
// sinon elle n'est pas proposée.
const lignesCandidates = (ctx, pcts) => {
    const G = ctx.interroges;
    const out = [];
    const trie = [...pcts].sort((a, b) => a - b);
    const pousser = (gabarit, texte, vrai, cats, code = null) => out.push({ gabarit, texte, vrai, cats, code });
    ctx.cats.forEach((c, i) => {
        const p = pcts[i];
        const plus = `Plus de la moitié des ${G} ont choisi « ${c} ».`;
        if (p > 50) pousser('plus', plus, true, [c]);
        else if (p <= 40) pousser('plus', plus, false, [c], p === 25 ? 'degres_pour_pourcent' : null);
        const moins = `Moins de la moitié des ${G} ont choisi « ${c} ».`;
        if (p <= 40) pousser('moins', moins, true, [c]);
        else if (p > 50) pousser('moins', moins, false, [c]);
        const quart = `Un quart des ${G} ont choisi « ${c} ».`;
        if (p === 25) pousser('quart', quart, true, [c]);
        else if (p <= 10 || p >= 40) pousser('quart', quart, false, [c], 'parts_egales');
        const moitie = `La moitié des ${G} ont choisi « ${c} ».`;
        if (p === 50) pousser('moitie', moitie, true, [c]);
        else if (p === 25 || p <= 15) pousser('moitie', moitie, false, [c], p === 25 ? 'demi_disque' : null);
        const moinsChoisie = `« ${c} » est la réponse la moins choisie.`;
        if (p === trie[0] && trie[1] - trie[0] >= 10) pousser('moins_choisie', moinsChoisie, true, [c]);
        else if (p - trie[0] >= 10) pousser('moins_choisie', moinsChoisie, false, [c]);
    });
    for (let i = 0; i < 4; i++) {
        for (let j = i + 1; j < 4; j++) {
            const s = pcts[i] + pcts[j];
            const texte = `Les réponses « ${ctx.cats[i]} » et « ${ctx.cats[j]} » réunies font plus de la moitié des réponses.`;
            if (s >= 60) pousser('reunies', texte, true, [ctx.cats[i], ctx.cats[j]]);
            else if (s <= 40) pousser('reunies', texte, false, [ctx.cats[i], ctx.cats[j]]);
        }
    }
    return out;
};

/**
 * Quatre lignes, nbV vraies ; au plus une ligne par gabarit (sinon « Moins de
 * la moitié … » vraie revenait deux ou trois fois), une réponse au plus par
 * ligne simple (la ligne « réunies » peut reprendre une réponse).
 */
const choisirLignes = (candidates, nbV) => {
    const prises = [];
    const catsPrises = new Set();
    const gabaritsPris = new Set();
    const essayer = (vrai, combien) => {
        shuffle(candidates.filter((l) => l.vrai === vrai)).forEach((l) => {
            if (prises.filter((p) => p.vrai === vrai).length >= combien) return;
            if (gabaritsPris.has(l.gabarit)) return;
            if (l.cats.length === 1 && catsPrises.has(l.cats[0])) return;
            gabaritsPris.add(l.gabarit);
            if (l.cats.length === 1) catsPrises.add(l.cats[0]);
            prises.push(l);
        });
    };
    essayer(false, 4 - nbV);
    essayer(true, nbV);
    return prises.length === 4 ? shuffle(prises) : null;
};

const genLireVF = () => {
    // Le nombre de lignes vraies est tiré UNE fois (quota uniforme) ; seul le
    // disque est retiré si ses lignes ne suffisent pas.
    const nbV = randInt(1, 3);
    for (let essai = 0; essai < 60; essai++) {
        const ctx = randomChoice(CONTEXTES);
        const { pcts } = tirerDisque(randomChoice(['quart', 'moitie', 'plus']));
        const lignes = choisirLignes(lignesCandidates(ctx, pcts), nbV);
        if (!lignes) continue;
        const payload = makeVraiFaux(lignes.map((l) => l.texte), lignes.map((l) => (l.vrai ? 0 : 1)),
            introSondage(ctx) + RAPPEL_BROUILLON + '<p><b>Vrai ou faux ?</b></p>',
            { ...opts(L_LIRE), elements_additionnels: disqueSansNombre(ctx, pcts) });
        payload._meta.params = { pcts, nbV, distracteurs: lignes.filter((l) => !l.vrai && l.code).map((l) => l.code) };
        return payload;
    }
    // Repli déterministe vérifié : l'exemple de réussite arrondi (Sport 15,
    // Lecture 55, Jeux vidéo 25, Musique 5), une ligne par tournure.
    const ctx = CONTEXTES[0];
    const pcts = [15, 55, 25, 5];
    const lignes = [
        { texte: `Plus de la moitié des ${ctx.interroges} ont choisi « Lecture ».`, vrai: true },
        { texte: `Un quart des ${ctx.interroges} ont choisi « Jeux vidéo ».`, vrai: true },
        { texte: `La moitié des ${ctx.interroges} ont choisi « Sport ».`, vrai: false },
        { texte: 'Les réponses « Sport » et « Musique » réunies font plus de la moitié des réponses.', vrai: false },
    ];
    const payload = makeVraiFaux(lignes.map((l) => l.texte), lignes.map((l) => (l.vrai ? 0 : 1)),
        introSondage(ctx) + RAPPEL_BROUILLON + '<p><b>Vrai ou faux ?</b></p>',
        { ...opts(L_LIRE), elements_additionnels: disqueSansNombre(ctx, pcts) });
    payload._meta.params = { pcts, nbV: 2, distracteurs: [] };
    return payload;
};

// ═════════════════════════════════════════════════════════════
// CARTE « Calculer l'angle d'un secteur »
// ═════════════════════════════════════════════════════════════

// Total DIVISEUR de 360 → angle = effectif × (360 ÷ total) entier.
const DIVISEURS_360 = [20, 24, 30, 36, 40, 45, 60, 72, 90];

// Chaque contexte nomme ses objets : en-tête du tableau (entete), unité au
// pluriel et au singulier, « pour chaque … ». Le club d'échecs est l'exemple
// de réussite. Revue du coordinateur (2026-09-23) : une classe compte au plus
// 30 élèves (totalMax ; le tirage servait « 60 élèves d'une classe ») ; le
// groupe sanguin est retiré (des effectifs tirés au hasard donnaient autant
// d'élèves AB que O, invraisemblable).
const CTX_ANGLE = [
    { sujet: 'les couleurs préférées des élèves d\'une classe', entete: 'Couleur', cats: ['Bleu', 'Rouge', 'Vert', 'Jaune'], unite: 'élèves', uniteSing: 'élève', pourChaque: 'pour chaque couleur', totalMax: 30 },
    { sujet: 'les activités choisies par les membres d\'un club', entete: 'Activité', cats: ['Théâtre', 'Danse', 'Chorale', 'Échecs'], unite: 'membres', uniteSing: 'membre', pourChaque: 'pour chaque activité' },
    { sujet: 'les fruits ramassés dans un verger', entete: 'Fruit', cats: ['Pommes', 'Poires', 'Cerises', 'Prunes'], unite: 'fruits', uniteSing: 'fruit', pourChaque: 'de chaque sorte' },
    { sujet: 'les moyens de transport des habitants d\'une rue', entete: 'Transport', cats: ['À pied', 'Vélo', 'Bus', 'Voiture'], unite: 'personnes', uniteSing: 'personne', pourChaque: 'pour chaque moyen de transport' },
    { sujet: 'l\'âge des adhérents du club d\'échecs du collège', entete: 'Âge', cats: ['11 ans', '13 ans', '14 ans', '15 ans'], unite: 'adhérents', uniteSing: 'adhérent', pourChaque: 'pour chaque âge' },
];

/**
 * 4 effectifs DISTINCTS ≥ 2, somme = total (diviseur de 360) → 4 angles
 * entiers distincts. Trois coupures au hasard entre 1 et total − 1 : les
 * morceaux sont répartis uniformément (le tirage en chaîne donnait souvent un
 * morceau géant, « 51 élèves sur 60 ») ; aucun effectif au-dessus de 60 % du
 * total (l'exemple d'Eduscol en a un de 56 %).
 */
const tirerAngle = () => {
    const ctx = randomChoice(CTX_ANGLE);
    const totaux = DIVISEURS_360.filter((t) => t <= (ctx.totalMax || 90));
    for (let essai = 0; essai < 200; essai++) {
        const total = randomChoice(totaux);
        const coupes = new Set();
        for (let k = 0; k < 20 && coupes.size < 3; k++) coupes.add(randInt(1, total - 1));
        if (coupes.size < 3) continue;
        const [c1, c2, c3] = [...coupes].sort((x, y) => x - y);
        const effs = shuffle([c1, c2 - c1, c3 - c2, total - c3]);
        if (effs.some((e) => e < 2 || e > 0.6 * total)) continue;
        if (new Set(effs).size !== 4) continue;
        const coef = 360 / total;
        const angles = effs.map((e) => e * coef);
        // Second chemin : angles entiers, somme 360.
        if (angles.some((x) => !Number.isInteger(x)) || angles.reduce((s, x) => s + x, 0) !== 360) {
            throw new Error(`gen_164 : angles ${angles}`);
        }
        return { ctx, total, effs, angles, coef };
    }
    // Repli déterministe vérifié : 5 + 8 + 4 + 7 = 24 (possible pour une
    // classe), coefficient 15, angles 75, 120, 60 et 105 (somme 360).
    return { ctx, total: 24, effs: [5, 8, 4, 7], angles: [75, 120, 60, 105], coef: 15 };
};

// Le tableau du cours : une ligne des réponses, une ligne des effectifs, et la
// colonne « Total ».
const tableAngle = (d) => tableEnonce(
    ligneTable(d.ctx.entete, [...d.ctx.cats, 'Total']),
    ligneTable('Effectif', [...d.effs, d.total]));

// Énoncé des cartes « angle » : intro + tableau d'effectifs (HTML) + rappel + question.
const enonceAngle = (d, question) =>
    `<p>On veut représenter ${d.ctx.sujet} par un diagramme circulaire. `
    + `Le tableau donne le nombre ${deU(d.ctx.unite)} ${d.ctx.pourChaque}.</p>${tableAngle(d)}`
    + `${RAPPEL_BROUILLON}<p><b>${question}</b></p>`;

const genAngleSaisie = () => {
    const d = tirerAngle();
    const i = randInt(0, 3);
    const payload = makeSaisie(String(d.angles[i]),
        enonceAngle(d, `Quel est l'angle du secteur « ${d.ctx.cats[i]} » ?`),
        { ...opts(L_ANGLE), strict: false, suffixe: '°' });
    payload._meta.params = { total: d.total, effs: d.effs, secteur: d.ctx.cats[i], angle: d.angles[i] };
    return payload;
};

const genAngleTrous = () => {
    const d = tirerAngle();
    // La forme du cours : le disque entier, puis le coefficient, puis chaque réponse.
    const lignes = [
        `${d.total} ${d.ctx.unite} pour 360°, donc 1 ${d.ctx.uniteSing} pour {{${d.coef}}}°`,
        ...d.ctx.cats.map((c, i) => `${c} : ${d.effs[i]} ${d.ctx.unite}, soit {{${d.angles[i]}}}°`),
    ];
    const payload = makeTexteTrou(lignes.join('\n'),
        enonceAngle(d, 'Calcule l\'angle de chaque secteur.'),
        { ...opts(L_ANGLE), mode: 'saisie', strict: false });
    payload._meta.params = { total: d.total, effs: d.effs, coef: d.coef, angles: d.angles };
    return payload;
};

// Les quatre calculs du QCM, même forme e × (A ÷ B) : { code, a, b }.
const CALCULS_ANGLE = (total) => [
    { code: null, a: 360, b: total },
    { code: 'degres_pour_pourcent', a: 100, b: total },
    { code: 'demi_disque', a: 180, b: total },
    { code: 'mauvais_diviseur', a: 360, b: 100 },
];
const calculTex = (e, c) => tex(`${e} \\times (${c.a} \\div ${c.b})`);

const genAngleQcm = () => {
    const d = tirerAngle();
    const i = randInt(0, 3);
    const e = d.effs[i];
    const calculs = CALCULS_ANGLE(d.total);
    // Second chemin : la clé vaut l'angle du secteur, aucun distracteur ne le vaut.
    const valeurs = calculs.map((c) => (e * c.a) / c.b);
    if (valeurs[0] !== d.angles[i] || valeurs.slice(1).some((v) => Math.abs(v - valeurs[0]) < 1e-9)
        || new Set(valeurs.map((v) => v.toFixed(6))).size !== 4) {
        throw new Error(`gen_164 : calculs d'angle ${e} / ${d.total}`);
    }
    const choix = calculs.map((c) => calculTex(e, c));
    const payload = makeQcm(choix, choix[0],
        enonceAngle(d, `Quel calcul donne l'angle du secteur « ${d.ctx.cats[i]} » ?`),
        opts(L_ANGLE));
    payload._meta.params = {
        total: d.total, effectif: e, angle: d.angles[i],
        distracteurs: calculs.slice(1).map((c) => c.code),
    };
    return payload;
};

// Leurres du relier : angles d'erreurs nommées, calculés sur une réponse affichée.
const LEURRES_ANGLE = {
    demi_disque: (e, total) => (e * 180) / total,
    degres_pour_pourcent: (e, total) => (e * 100) / total,
    mauvais_diviseur: (e) => (e * 360) / 100,
};
const angleTexte = (a) => `${a}°`;

/**
 * Deux leurres pour les réponses d'indices idx : familles différentes, valeurs
 * entières différentes, distinctes de TOUS les angles du tableau, dont au moins
 * un strictement entre le plus petit et le plus grand angle juste. Une paire
 * tirée au hasard parmi celles qui conviennent, null s'il n'y en a pas.
 */
const leurresRelier = (d, idx) => {
    const vrais = idx.map((k) => d.angles[k]);
    const mini = Math.min(...vrais);
    const maxi = Math.max(...vrais);
    const candidats = [];
    idx.forEach((k) => {
        Object.entries(LEURRES_ANGLE).forEach(([code, f]) => {
            const v = f(d.effs[k], d.total);
            if (Number.isInteger(v) && v > 0 && !d.angles.includes(v)) candidats.push({ code, valeur: v });
        });
    });
    const paires = [];
    for (let p = 0; p < candidats.length; p++) {
        for (let q = p + 1; q < candidats.length; q++) {
            const [l1, l2] = [candidats[p], candidats[q]];
            if (l1.code === l2.code || l1.valeur === l2.valeur) continue;
            if (![l1, l2].some((l) => l.valeur > mini && l.valeur < maxi)) continue;
            paires.push([l1, l2]);
        }
    }
    return paires.length ? randomChoice(paires) : null;
};

const assemblerRelier = (d, idx, leurres) => {
    const pairs = idx.map((k) => ({ source: d.ctx.cats[k], target: angleTexte(d.angles[k]) }));
    const cibles = leurres.map((l) => ({ target: angleTexte(l.valeur), code: l.code }));
    // Second chemin : chaque source à son angle (effectif × coefficient), cinq
    // cibles distinctes, un leurre au moins entre le plus petit et le plus grand angle juste.
    idx.forEach((k) => { if (d.effs[k] * d.coef !== d.angles[k]) throw new Error('gen_164 : relier, angle faux'); });
    const toutes = [...pairs.map((p) => p.target), ...cibles.map((l) => l.target)];
    if (new Set(toutes).size !== 5) throw new Error('gen_164 : relier, cibles en double');
    const vrais = idx.map((k) => d.angles[k]);
    if (!leurres.some((l) => l.valeur > Math.min(...vrais) && l.valeur < Math.max(...vrais))) {
        throw new Error('gen_164 : relier, aucun leurre intercalé');
    }
    const payload = makeRelier(shuffle(pairs),
        enonceAngle(d, 'Relie chacune de ces trois réponses à l\'angle de son secteur. Deux angles sont en trop.'),
        { ...opts(L_ANGLE), cibles_leurres: cibles });
    payload._meta.params = {
        total: d.total, effs: d.effs, sources: idx.map((k) => d.ctx.cats[k]),
        distracteurs: Object.fromEntries(cibles.map((l) => [l.target, l.code])),
    };
    return payload;
};

const genAngleRelier = () => {
    for (let essai = 0; essai < 120; essai++) {
        const d = tirerAngle();
        const idx = shuffle([0, 1, 2, 3]).slice(0, 3);
        const leurres = leurresRelier(d, idx);
        if (leurres) return assemblerRelier(d, idx, leurres);
    }
    // Repli déterministe vérifié : total 24 (coefficient 15), effectifs 3, 5,
    // 12, 4 ; les trois premières réponses (45°, 75°, 180°) ; leurres
    // demi_disque de 12 (12 × 180 ÷ 24 = 90°) et degres_pour_pourcent de 12
    // (12 × 100 ÷ 24 = 50°), tous deux entre 45° et 180°.
    const d = { ctx: CTX_ANGLE[0], total: 24, effs: [3, 5, 12, 4], angles: [45, 75, 180, 60], coef: 15 };
    return assemblerRelier(d, [0, 1, 2], [{ code: 'demi_disque', valeur: 90 }, { code: 'degres_pour_pourcent', valeur: 50 }]);
};

// ═════════ Contrat des distracteurs (données pures, jamais lues à l'exécution) ═════════

export const REGLES_DISTRACTEURS_QCM = {
    lire_qcm_unique: {
        support: 'disque SANS aucun nombre (légende des réponses), quatre secteurs, parts multiples de 5 % ; le secteur demandé fait un quart (25 %), la moitié (50 %) ou plus de la moitié (55, 60 ou 65 %), un tiers des tirages chacun ; les trois autres secteurs sont deux à deux distincts',
        choix: 'quatre réponses FIXES, celles de la décision : « Un quart », « La moitié », « Trois quarts », « Plus de la moitié » ; une seule est vraie, vérifié sur la part dessinée (throw sinon) ; « Trois quarts » n\'est jamais la clé (un secteur de trois quarts rendrait vraie aussi « Plus de la moitié »)',
        familles: {
            degres_pour_pourcent: 'l\'angle en degrés lu comme un pourcentage (DEPP 2de 2025 q.15 : 90 % pour un angle droit, 6,8 %) : un quart dit « Plus de la moitié » ; un demi-disque (180°) dit aussi « Plus de la moitié »',
            demi_disque: 'l\'angle plein pris pour 180° (q.15 : 45 % pour un angle droit, 12,2 %) : un quart dit « La moitié »',
            parts_egales: 'le disque partagé en parts égales (q.15 : 20 % pour cinq secteurs, 4,7 %) : avec quatre secteurs, toute réponse dite « Un quart »',
            complementaire: 'la part des autres réponses lue à la place du secteur (DEPP 4e 2023 q.13, « secteurs blancs ») : un quart dit « Trois quarts »',
            repere_voisin: 'NON chiffrée, mode auto, À ARBITRER : la part estimée au repère voisin (un demi-disque lu « Trois quarts », un secteur un peu plus grand que la moitié lu « La moitié » ou « Trois quarts »)',
        },
        par_cible: {
            quart: 'La moitié = demi_disque ; Plus de la moitié = degres_pour_pourcent ; Trois quarts = complementaire',
            moitie: 'Un quart = parts_egales ; Plus de la moitié = degres_pour_pourcent ; Trois quarts = repere_voisin',
            plus: 'Un quart = parts_egales ; La moitié = repere_voisin ; Trois quarts = repere_voisin',
        },
        ecart: 'les décisions demandaient les trois familles DEPP comme distracteurs ; chiffrées sur un angle droit, elles ne donnent trois mauvaises réponses plausibles que pour le quart (au-delà, 180 % ou 135 % ne sont pas des parts) ; un QCM toujours sur le quart aurait toujours la même clé',
    },
    angle_qcm_unique: {
        support: 'tableau de quatre effectifs distincts au moins 2, total diviseur de 360 (20 à 90) ; quatre calculs de même forme e × (A ÷ B), sans résultat, en KaTeX',
        cle: 'e × (360 ÷ total) : le coefficient du cours (360 ÷ 24 = 15)',
        familles: {
            degres_pour_pourcent: 'e × (100 ÷ total) : le pourcentage calculé à la place de l\'angle',
            demi_disque: 'e × (180 ÷ total) : le disque entier pris pour 180° au lieu de 360°',
            mauvais_diviseur: 'e × (360 ÷ 100) : divisé par 100 au lieu du total, l\'effectif traité comme un pourcentage (« pourcentage × 3,6 » de 5e appliqué à l\'effectif)',
        },
        garantie: 'les quatre valeurs sont deux à deux distinctes pour tout total du tirage (il faudrait un total de 50 ou 100), vérifié à chaque tirage (throw sinon) ; la clé vaut l\'angle du tableau',
        residuel: 'À ARBITRER : la clé est toujours le calcul de plus grande valeur, les trois familles diminuant l\'angle ; options sans résultat affiché',
    },
    angle_relier: 'trois réponses du tableau, cinq angles : les trois justes et deux leurres de familles différentes (demi_disque e × 180 ÷ total, degres_pour_pourcent e × 100 ÷ total, mauvais_diviseur e × 360 ÷ 100) calculés sur une réponse affichée, entiers, distincts des angles justes et entre eux ; au moins un leurre strictement entre le plus petit et le plus grand angle juste (ranger ne suffit plus) ; nouveau tirage sinon, repli vérifié (3, 5, 12 et 4 sur 24 : 45°, 75°, 180°, leurres 90° et 50°)',
    lire_tableau_vf: 'quatre lignes, une à trois vraies ; une réponse au plus par ligne simple, une ligne au plus par tournure (plus de la moitié, moins de la moitié, un quart, la moitié, la moins choisie, réunies) ; ligne écrite seulement si l\'écart entre ce qu\'elle affirme et ce qui est dessiné est d\'au moins 10 % (5 % pour « plus / moins de la moitié » face à un secteur de 55 %, le niveau de l\'exemple de réussite) ; fausses nommées quand une erreur l\'explique : degres_pour_pourcent (un quart dit « plus de la moitié »), demi_disque (un quart dit « la moitié »), parts_egales (un secteur dit « un quart »)',
};

// ─── Registry & Export ───────────────────────────────────────

const GENERATORS = {
    lire_qcm_unique: genLireQcm,
    lire_texte_trou_saisie: genLireTrous,
    lire_tableau_vf: genLireVF,
    angle_texte: genAngleSaisie,
    angle_texte_trou_saisie: genAngleTrous,
    angle_qcm_unique: genAngleQcm,
    angle_relier: genAngleRelier,
};

const FORMAT_LABELS = {
    qcm_unique: 'QCM', qcm_multiple: 'QCM Multi', texte: 'Saisie',
    texte_trou_drag: 'Drag', texte_trou_saisie: 'Saisie trous',
    relier: 'Relier', ordonner: 'Ordonner', classer: 'Classer', tableau_vf: 'Vrai/Faux',
};
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter((k) => k.startsWith(`${prefix}_`))
        .map((k) => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));

export const CATEGORIES = [
    { id: 'lire', label: L_LIRE, formatsList: buildFormats('lire') },
    { id: 'angle', label: L_ANGLE, formatsList: buildFormats('angle') },
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
